import { Component, Inject, OnInit } from '@angular/core';
import { SchedulableItem } from '../objects/scheduler-item';
import { data_get, fallback, filled, OptionalValue, spf } from '../../../shared/utils/common';
import { DIALOG_DATA } from '../../../services/dialog.service';
import { FieldmagicCalendarTimelineView, NewSchedulerSettings } from '../new-scheduler.component';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'fieldmagic-calendar-dialog',
  template: `
    <fieldmagic-dialog
      [label]="label$ | async"
      icon="calendar"
      [instance]="this"
    >
      <ng-template fieldmagicDialogButtonsTmp></ng-template>
      <ng-template fieldmagicDialogContentTmp>
        <app-new-scheduler
          mode="simple"
          [schedulable]="schedulable"
          [timelineView]="timelineView"
          [settings]="settings"
        >
        </app-new-scheduler>
      </ng-template>
    </fieldmagic-dialog>
  `,
})
export class FieldmagicSchedulerDialogComponent implements OnInit {
  readonly schedulable: OptionalValue<SchedulableItem> = data_get(this._data, 'schedulable');
  readonly timelineView: FieldmagicCalendarTimelineView = fallback(this._data.timeline_view, {
    to: () => 'day' as FieldmagicCalendarTimelineView,
  });

  readonly settings: OptionalValue<NewSchedulerSettings> = data_get(this._data, 'calendar_settings');

  readonly label$ = new BehaviorSubject<string>('Scheduler');

  constructor(
    @Inject(DIALOG_DATA) private readonly _data: FieldmagicSchedulerDialogData,
  ) {}

  ngOnInit(): void {
    if (filled(this._data.additional_label)) {
      this.label$.next(spf('Scheduler: %s', {
        args: [this._data.additional_label],
      }));
    }
  }
}

export type FieldmagicSchedulerDialogData = {
  schedulable?: SchedulableItem;
  timeline_view?: FieldmagicCalendarTimelineView;
  additional_label?: string;

  calendar_settings?: NewSchedulerSettings;
}